import React from "react";
import PropTypes from "prop-types";
import getClassNameFactory from "@wel-ui/utility-class-names";
import "./ExistingUserStep.css";

import Button from "@wel-ui/components/Button";
import "@wel-ui/components/Button/index.css";
import Group from "@wel-ui/components/Group";
import "@wel-ui/components/Group/index.css";
import Heading from "@wel-ui/components/Heading";
import "@wel-ui/components/Heading/index.css";
import VerticalSpacing from "@wel-ui/components/VerticalSpacing";
import "@wel-ui/components/VerticalSpacing/index.css";

import { startsWithVowel } from "../../helpers";

const getClassName = getClassNameFactory("ExistingUserStep");

const ExistingUserStep = ({
  onFinalStepClick,
  onStartAgainClick,
  finalStep
}) => {
  const { label, resultsUrl } = finalStep;

  return (
    <div className={getClassName()}>
      <VerticalSpacing>
        <Heading type="l" rank="1">
          We deliver the world’s most innovative tax and accounting solutions.{" "}
          <strong>
            We found {startsWithVowel(label) ? "an" : "a"} {label} SUPER HERO for
            you.
          </strong>
        </Heading>
      </VerticalSpacing>
      <Group>
        <Group.Item>
          <Button
            color="primary"
            kind="button"
            onClick={e => onFinalStepClick(e, resultsUrl)}
          >
            See my results
          </Button>
        </Group.Item>
        <Group.Item>
          <Button color="secondary" kind="button" onClick={onStartAgainClick}>
            Find another solution
          </Button>
        </Group.Item>
      </Group>
    </div>
  );
};

ExistingUserStep.displayName = "SolutionFinderExistingUserStep";

ExistingUserStep.propTypes = {
  onFinalStepClick: PropTypes.func.isRequired,
  onStartAgainClick: PropTypes.func.isRequired,
  finalStep: PropTypes.object.isRequired
};

export default ExistingUserStep;



// WEBPACK FOOTER //
// ./js/components/SolutionFinder/ExistingUserStep.js